import PropTypes from 'prop-types';

export default PropTypes.shape({
  uuid: PropTypes.string.isRequired,
  app: PropTypes.string.isRequired,

  name: PropTypes.string,
  desc: PropTypes.string,
  images: PropTypes.string.isRequired,
});
